<template>
  <div class="columns is-vcentered is-marginless border-color-select" v-if="item">
    <div  class="column is-narrow  is-paddingless">
      <app-logo readOnly class="image is-96x96"
                :elementId="item.id"
                :libelleElement="$t(`demandeLogistique.patrimoine.${item.typeItem}`,
                {code: item.code})"></app-logo>
    </div>

    <div class="column pdl-20px">
      <span class="has-text-weight-bold">
        {{$t(`demandeLogistique.patrimoine.${item.typeItem}`, {code: item.code})}}
      </span><br/>
      <span class="is-size-7 has-text-default">
        {{ importedFunction.adressFullStringGetter(item.adresse)}}
      </span><br/>
    </div>
    <div class="column" v-if="item.format">
      <b-field :label="$t('demandeLogistique.patrimoine.format')">
        <span class="is-size-6 has-text-default">
          {{item.format}}
        </span>
      </b-field>
    </div>
    <div class="column" v-if="item.typeMateriel">
      <b-field :label="$t('demandeLogistique.patrimoine.typeMateriel')">
        <span class="is-size-6 has-text-default">
          {{item.typeMateriel}}
        </span>
      </b-field>
    </div>
    <div class="column" v-if="item.dispositifSupport">
      <b-field :label="$t('demandeLogistique.patrimoine.dispositifSupport')">
        <span class="is-size-6 has-text-default">
          {{item.dispositifSupport}}
        </span>
      </b-field>
    </div>
    <div class="column" v-if="item.dispositifType">
      <b-field :label="$t('demandeLogistique.patrimoine.dispositifType')">
        <span class="is-size-6 has-text-default">
          {{item.dispositifType}}
        </span>
      </b-field>
    </div>
    <div class="column" v-if="item.etat">
      <b-field :label="$t('demandeLogistique.patrimoine.etat')">
        <span class="is-size-6 has-text-default">
          {{$t(getLibelleEtat(item.etat))}}
        </span>
      </b-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import { get as getFace } from '@/api/gabed/face/index';
import { get as getMateriel } from '@/api/gabed/materiel/index';
import { get as getDispositif } from '@/api/gabed/dispositif/index';
import { get as getEmplacement } from '@/api/gabed/emplacement/index';
import messageErreur from '@/services/general/messageErreur';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

const Attachments = createNamespacedHelpers('attachments');

export default {
  components: {
    appLogo: Logo,
  },
  props: {
    faceId: {
      type: String,
      required: false,
    },
    materielId: {
      type: String,
      required: false,
    },
    dispositifId: {
      type: String,
      required: false,
    },
    emplacementId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      importedFunction: {
        adressFullStringGetter,
      },
      item: null,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    generateItem(data) {
      return {
        id: null,
        code: null,
        etat: null,
        adresse: null,
        typeMateriel: null,
        format: null,
        dispositifSupport: null,
        dispositifType: null,
        typeItem: '',
        ...data,
      };
    },
    getLibelleEtat(etat) {
      return ETAT_DISPOSITIF_PUBLICITAIRE.find((el) => {
        return el.value === etat;
      }).libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.faceId) {
        const { result } = (await getFace(this.faceId)).data;
        this.item = this.generateItem({
          id: result.id,
          code: result.code,
          etat: result.etat,
          adresse: result.materiel.dispositif.adresse,
          format: result.materiel.format.libelle,
          typeItem: 'face',
        });
        await this.setAttachmentContext({ module: 'Materiel' });
        await this.setAttachmentElementId({ id: result.materiel.id });
      }
      if (this.materielId) {
        const { result } = (await getMateriel(this.materielId)).data;
        this.item = this.generateItem({
          id: result.id,
          code: result.code,
          etat: result.etat,
          adresse: result.dispositif.adresse,
          typeMateriel: result.type.libelle,
          typeItem: 'materiel',
        });
        await this.setAttachmentContext({ module: 'Materiel' });
        await this.setAttachmentElementId({ id: result.id });
      }
      if (this.dispositifId) {
        const { result } = (await getDispositif(this.dispositifId)).data;
        this.item = this.generateItem({
          id: result.id,
          code: result.code,
          etat: result.etat,
          adresse: result.adresse,
          dispositifSupport: result.dispositifSupport ? result.dispositifSupport.libelle : '',
          dispositifType: result.dispositifType ? result.dispositifType.libelle : '',
          typeItem: 'dispositif',
        });
        await this.setAttachmentContext({ module: 'Dispositif' });
        await this.setAttachmentElementId({ id: result.id });
      }
      if (this.emplacementId) {
        const { result } = (await getEmplacement(this.emplacementId)).data;
        this.item = this.generateItem({
          id: result.id,
          code: result.code,
          etat: result.etat,
          adresse: result.adresseCadastrale,
          typeItem: 'emplacement',
        });
        await this.setAttachmentContext({ module: 'EmplacementAdresse' });
        await this.setAttachmentElementId({ id: result.id });
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      this.chargement = false;
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
